export default {
    devlinkComponent: {
        componentType: "Hero",
        props: {}
    }
};
